export const RELAYED_TURN_COMMANDS = {
  Next: 'next',
  Submit: 'submit',
} as const;

export type RelayedTurnCommand =
  (typeof RELAYED_TURN_COMMANDS)[keyof typeof RELAYED_TURN_COMMANDS];

/**
 * One turn of speech recognised on the phone rather than in this page.
 *
 * `command` is the phone's own control, carried alongside the words instead of
 * spoken into them: the responder taps Next, and the transcript stays the answer
 * it was.
 */
export interface RelayedTranscriptTurn {
  readonly transcript: string;
  readonly isFinal: boolean;
  readonly command: RelayedTurnCommand | null;
}

/**
 * The phone driving this page. `uniqueId` is what makes a session relayed: a
 * page with none is running on the responder's own device, holds its own
 * microphone, and never sees a relayed turn.
 */
export interface MobileRelayPort {
  readonly uniqueId: string | null;
  readonly subscribe: (
    listener: (turn: RelayedTranscriptTurn) => void
  ) => () => void;
  readonly syncRecordingStarted: () => Promise<void>;
  readonly linkAudio: (insightId: string) => Promise<void>;
  readonly endSession: (args: {
    readonly reason: string;
    readonly redirectUrl: string | null;
  }) => Promise<void>;
}
